const USER_STATE_LOCAL_STORAGE_KEY = '@userState';
const USER_REDUCER_NAME = 'user';

const LOGIN_MODAL_TYPE = {
  NOT_SEOUL_2033_USER: 'notSeoul2033User',
  LOW_LEVEL_USER: 'lowLevelUser',
};

export { USER_STATE_LOCAL_STORAGE_KEY, USER_REDUCER_NAME, LOGIN_MODAL_TYPE };
